@if (isDesktopSize()) {
  <app-side-nav-desktop></app-side-nav-desktop>
} @else {
  <app-side-nav-mobile></app-side-nav-mobile>
}
